export default function (event) {
  const value = event.target.value + event.key;
  const phoneRegex = /\+?[\s0-9()]*$/;
  if (!phoneRegex.test(value)) {
    event.preventDefault();
  }
}
